import { Injectable } from '@angular/core';
import { BaseSite, BaseSiteService } from '@spartacus/core';
import { take } from 'lodash';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SlbBaseSitesService {

  constructor(
    private _baseSite: BaseSiteService
  ) { }

  getActive(): Observable<BaseSite | undefined> {
    return this._baseSite
      .getActive()
      .pipe(
        switchMap((siteUid) => this._baseSite.get(siteUid)),
      );
  }

  getConfigurationByKey(
    key: String,
  ): Observable<{ code: string; value?: string } | undefined> {
    return this.getConfigurations().pipe(
      map((configurations) =>
        configurations?.find((configuration) => configuration.code === key),
      ),
    );
  }

  getConfigurations(): Observable<{ code: string; value?: string }[] | undefined> {
    return this.getActive().pipe(
      filter((site) => !!site?.configurations),
      map((site) => site?.configurations),
    );
  }
}
